import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: false,
    username: 'Logged Out',
    nickname: 'Logged Out',
    email: '',
    avatar: '',
    loggedIn: false,
    cordova: false,
    collections: [],
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  },
});
